export const getVariantFromMessageStatus = (messageStatus) => {
  if (messageStatus.toLowerCase() === "received") return "success";
  return "gray";
};
